import type { FormControl } from "./actions-reducer";

export const INITIAL_ATTENDANCE_VALUES: FormControl = {
  values: {},
  initialValues: {},
  pendingChanges: false,
  invalidFields: [],
  isExtratoCopiado: false,
};
